import { isNonEmpty } from '@sgme/fp';
import { ColTypeDef, ICellEditorParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { isEqual } from 'lodash-es';
import { useMemo } from 'react';
import { LabelCellRenderer } from 'routes/secondary-market-batch/grid/components/label-cell-renderer';
import { formatSettlementType } from 'routes/secondary-market-batch/grid/utils/format-settlement-type';
import { CpOrderSettlementType } from 'state/secondaryMarket/cpOrder/referential/client/client.model';
import { Sales } from 'state/secondaryMarket/shared/referential/referential.model';
import { RowData } from 'state/workspaces/secondary-market/batch/model';

export function useSettlementsColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  return useMemo(
    () => ({
      cellEditor: 'agRichSelectCellEditor',
      equals: isEqual,
      valueFormatter: ({ value }: ValueFormatterParams<RowData>) => {
        const settlementType = value as CpOrderSettlementType | undefined;
        return formatSettlementType(settlementType) ?? '';
      },
      filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['contains', 'notContains'],
      },
      filterValueGetter: ({ getValue, colDef }: ValueGetterParams<RowData>) => {
        const value = (colDef.field ? getValue(colDef.field) : undefined) as string | undefined;
        return formatSettlementType(value as CpOrderSettlementType | undefined);
      },
      cellEditorParams: {
        multiSelect: false,
        allowTyping: true,
        filterList: true,
        highlightMatch: true,
        values: ({ colDef, data }: ICellEditorParams<RowData, Sales>) => {
          const settlements = data.metadata[colDef.context.metadataId] as CpOrderSettlementType[] | undefined;
          return (
            settlements?.filter(
              s => isNonEmpty(s.description) && isNonEmpty(s.marketType) && isNonEmpty(s.settlementType),
            ) ?? []
          );
        },
        formatValue: formatSettlementType,
      },
      cellRenderer: LabelCellRenderer,
    }),
    [],
  );
}
